import { useMemo,useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomButton from '@/components/CustomButton'
import PaymentMethods from '../components/PaymentMethods'
import { useMerchantConfig } from '@/hooks'
import { CardType } from '../index.type'

interface AddCardProps {
  cardType?: CardType
}

export default function AddCard({ cardType = CardType.ElectronicCard }: AddCardProps) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { merchantConfig, actions } = useMerchantConfig()

  useEffect(() => {
    actions.fetchMerchantConfig()
  }, [])

  // 根据卡片类型确定跳转路由
  const applyRoute = cardType === CardType.ElectronicCard
    ? '/card/apply-card?type=electronic'
    : '/card/apply-physical-card?type=physical'

  // 根据卡片类型确定标题
  const cardTitle = cardType === CardType.ElectronicCard
    ? t('环球精英电子卡')
    : t('环球精英实体卡')

  // 开卡费用
  const cardFee = cardType === CardType.ElectronicCard ? merchantConfig?.card_fee : merchantConfig?.physical_card_fee

  const cardView = useMemo(
    () => (
      <div className="flex flex-col items-center">
        <div className="card w-full">
          <img className="w-full" src={cardType === CardType.ElectronicCard ? '/images/card/rfpay-electronic.png' : '/images/card/rfpay-physical.png'} />
        </div>

        <div className="text-center my-6">
          <div className="text-6.5 font-semibold text-black">{cardTitle}</div>
        </div>
        <div className="mb-5">
          <PaymentMethods />
        </div>
        <div className="space-y-2 mb-6 w-full">
          <div className="flex items-baseline">
            <div className="rounded-full w-1 h-1 bg-black flex-shrink-0 mr-2" ></div>
            <div className="text-sm text-black font-extralight">{t('现金或加密货币均可消费全球各地商户均可使用Master借记卡')}</div>
          </div>
          <div className="flex items-baseline">
            <div className="rounded-full w-1 h-1 bg-black flex-shrink-0 mr-2"></div>
            <div className="text-sm text-black font-extralight ">{t('多种主流加密资产存入支持')}</div>
          </div>
          <div className="flex items-baseline">
            <div className="rounded-full w-1 h-1 bg-black flex-shrink-0 mr-2"></div>
            <div className="text-sm text-black font-extralight">{t('最优实时汇率汇款最高48小时汇率保证')}</div>
          </div>
        </div>
        <div className="w-full flex flex-col items-center">
          <CustomButton onClick={() => navigate(applyRoute)} >{t('申请卡XUSD', { amount: cardFee })}</CustomButton>
          <div className="text-xs text-center text-black/44 my-5">{t('激活卡片首次最低需充值XUSD', { amount: cardFee })}</div>
        </div>
      </div>
    ),
    [navigate, t, cardFee, applyRoute, cardTitle]
  )

  return (
    <div className="px-6 py-6">
      {cardView}
    </div>
  )
}